var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArcticons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arcticons:eset-payment-protection"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.4375 36.8521V15.1667C63.4375 14.3931 63.1302 13.6513 62.5832 13.1043C62.0363 12.5573 61.2944 12.25 60.5208 12.25H9.47917C8.70562 12.25 7.96375 12.5573 7.41677 13.1043C6.86979 13.6513 6.5625 14.3931 6.5625 15.1667V54.8333C6.5625 55.6069 6.86979 56.3487 7.41677 56.8957C7.96375 57.4427 8.70562 57.75 9.47917 57.75H49.2406M6.5625 22.8025H63.4375",
    stroke: "#EA3E2A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M54.67 60.6668C57.7089 59.7379 60.4148 57.9508 62.462 55.5204C64.5093 53.09 65.8107 50.1198 66.2098 46.9672C66.4061 44.1661 66.3895 41.3542 66.1602 38.5556C66.1295 38.1146 65.9356 37.7008 65.6164 37.3951C65.2971 37.0893 64.8754 36.9134 64.4335 36.9018C61.2241 37.0425 58.0853 35.9326 55.6777 33.8058C55.4092 33.5413 55.0475 33.3931 54.6707 33.3931C54.2939 33.3931 53.9322 33.5413 53.6637 33.8058C51.2561 35.9326 48.1173 37.0425 44.9079 36.9018C44.466 36.9134 44.0443 37.0893 43.725 37.3951C43.4058 37.7008 43.2119 38.1146 43.1812 38.5556C42.9519 41.3542 42.9353 44.1661 43.1316 46.9672C43.5306 50.1196 44.8318 53.0897 46.8788 55.52C48.9258 57.9504 51.6313 59.7377 54.67 60.6668ZM54.67 60.6668V33.3916",
    stroke: "#EA3E2A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcticons);
export default __webpack_public_path__ + "static/media/arcticons.3016c94023ed56f441d166a412cd8685.svg";
export { ForwardRef as ReactComponent };